import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import { virtualPageView } from '../../googleTagManager';
import { dineAroundDetailsPage, swimmingPage } from '../../utils';
import '../entertainment/Entertainment.scss';
import EntertainmentCategory from '../entertainmentCategory/EntertainmentCategory';

const DineAround = ({
  title = '',
  subTitle = '',
  dineAroundItems,
  resId = 0,
  siteCode = '',
  getAvailableEntertainments = () => { },
  shouldFetchBookedEntertainments = false,
  getBookedEntertainments = () => { },
  shouldFetchAvailableEntertainments,
  shouldSkip,
  bookedEvents = [],
  detailPage = dineAroundDetailsPage,
  isSummaryPage = false,
}) => {
  const history = useHistory();

  useEffect(() => {
    virtualPageView('plan my day', 'book entertainment', '/ga-virtual/plan-my-day/book-entertainment');
  }, []);

  useEffect(() => {
    if (shouldFetchAvailableEntertainments) getAvailableEntertainments(siteCode);
  }, [
    shouldFetchAvailableEntertainments,
    getAvailableEntertainments,
    siteCode,
  ]);

  useEffect(() => {
    if (shouldFetchBookedEntertainments) getBookedEntertainments(resId, siteCode);
  }, [
    resId,
    siteCode,
    shouldFetchBookedEntertainments,
    getBookedEntertainments,
  ]);

  useEffect(() => {
    if (shouldSkip) history.push(swimmingPage);
  }, [shouldSkip, history]);

  return (
    <div>
      <div className={classnames('entertainment-main-container', !isSummaryPage && 'notSummaryPage')}>
        <div className="titles">
          <div className="title">{!isSummaryPage ? title : ''}</div>
          <div className="sub-title">{subTitle}</div>
        </div>
        <div className={classnames('entertainments', !isSummaryPage && 'notSummaryPage')}>
          {dineAroundItems.filter(({ events }) => events && events.length > 0).map(({ date, events }, index) => (
            <EntertainmentCategory
              key={index}
              categoryIndex={index}
              date={date}
              events={events}
              bookedEvents={bookedEvents}
              detailPage={detailPage}
            />
          ))}
        </div>
      </div>
    </div>

  );
};

DineAround.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  dineAroundItems: PropTypes.array,
  resId: PropTypes.number,
  siteCode: PropTypes.string,
  getAvailableEntertainments: PropTypes.func,
  shouldFetchBookedEntertainments: PropTypes.bool,
  getBookedEntertainments: PropTypes.func,
  shouldFetchAvailableEntertainments: PropTypes.bool,
  shouldSkip: PropTypes.bool,
  bookedEvents: PropTypes.array,
  detailPage: PropTypes.string,
  isSummaryPage: PropTypes.bool,
};

export default DineAround;
